import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import QueueService from "../services/QueueService";

const useQueueService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new QueueService(client);
  }, [client]);

  return service;
};

export default useQueueService;
